import React from 'react';
import ReactDOM from 'react-dom';
// import { render } from 'react-dom';
// import { browserHistory } from 'react-router-dom';
// import createHistory from 'history/createBrowserHistory'
import { AppContainer } from 'react-hot-loader';
import { syncHistoryWithStore } from 'react-router-redux';
import { Router, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
// import { Route, Switch } from 'react-router' // react-router v4/v5
import { ConnectedRouter } from 'connected-react-router'

import Routes from './Routes';
import { configureStore } from './store/configureStore';

import './styles/css/bootstrap.min.css';
import './styles/css/font-awesome.min.css';
import './styles/css/AdminLTE.min.css';
import './styles/css/skin-blue.min.css';
import './styles/css/landingpage.css';
import './styles/scss/style.css';
import './styles/css/devStyle.css';
import './styles/css/devStyleLanding.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import '../node_modules/video-react/dist/video-react.css'
// import './styles/css/sideBarStyle.css';
// import 'bootstrap/dist/css/bootstrap.css';
import './styles/css/date-picker.css';
import App from './components/App';
// import Dashboard from './components/Index/dashboard';
// import NotFound from './components/common/404';
// import Index from './components';
// import FullCalendar from '@fullcalendar/react';
import './styles/css/newstyle.css';
import './styles/css/specialist-settings.css';
import './styles/css/specialist-requrements.css';
import './styles/css/specialist-profile.css';
import 'react-flags-select/css/react-flags-select.css';



// import './styles/css/dispute.css';

const createHistory = require("history").createBrowserHistory;

const initialState = {};
const history = createHistory();
const store = configureStore(initialState);
// const browserHistory = createBrowserHistory();

// Create an enhanced history that syncs navigation events with the store
// const history = syncHistoryWithStore(browserHistory, store);

// import App from './App';
// import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    // <Router history={history}>
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Router history={history}>
                <App history={history}>
                    <Route path="/" component={Routes} />
                    {/* <Route exact path="/fullcalendar" component={FullCalendar} /> */}
                </App>
            </Router>
        </ConnectedRouter>
    </Provider>,
    //  </Router>,
    document.getElementById('root')
);

if (module.hot) {
    module.hot.accept('./Routes', () => {
        const NewRoot = require('./Routes').default;
        ReactDOM.render(
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <Router history={history}>
                    <App>
                        <Route path="/" component={NewRoot} />
                    </App>
                    </Router>
                </ConnectedRouter>
            </Provider>,
            document.getElementById('root')
        );
    });
}
